import React from 'react';
import { Switch, Route } from 'react-router-dom';

import OrganizationPaymentView from './views/OrganizationPaymentView';

function App() {
  return (
    <Switch>
      <Route
        path="/payments/organization/:organizationSlug"
        component={OrganizationPaymentView}
      />
      <Route
        path="/payments/:organizationSlug"
        component={OrganizationPaymentView}
      />
    </Switch>
  );
}

export default App;
